import { Link } from 'react-router-dom';
import styled from 'styled-components';
import StatusTag from '@/components/StatusTag';

export const CustomStatusTag = styled(StatusTag)`
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:before {
      top: 4px !important;
    }
  }
`;

export const Box = styled.div`
  position: absolute;
  background: white;
  z-index: 1;
  border-radius: 4px;
  border: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-40']};
  top: 50px;
  right: 0;
  width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 440px;
  }
`;

export const JobDetails = styled.div`
  width: calc(100% - 55px);
`;

export const List = styled.ul`
  overflow-y: auto;
  max-height: 300px;
`;

export const ListItem = styled.li`
  display: flex;
`;

export const ListItemLink = styled(Link)`
  padding: 6px 12px;
  width: 100%;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${(props) => props.theme.colors['neutral-20']};
  }
`;

export const FirstRow = styled.div`
  display: flex;
  align-items: center;
`;

export const SecondRow = styled(FirstRow)`
  hr {
    margin: 4px 8px;
    border-color: ${(props) => props.theme.colors['neutral-80']};
  }
`;

export const LoadingArea = styled.div`
  padding: 15px;
`;

export const Text = styled.p`
  font-size: 14px;
  color: #202123;
  font-weight: 400;
  line-height: 21px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WhenToStart = styled(Text)`
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const JobTitle = styled(Text)`
  margin-right: 16px;
  font-weight: bold;
`;

export const NotFound = styled.p`
  text-align: center;
  padding: 15px;
  font-size: 14px;
  color: #202123;
`;

export const ErrorMessage = styled(NotFound)`
  color: red;
`;
